import { Vue, Component, toNative } from 'vue-facing-decorator';
import ProductCategoriesTable from 'components/ProductCategoriesTable/';
import { useRouter } from 'vue-router';
import Template from './template.vue';

@Component({
	components: {
		ProductCategoriesTable,
	},
	mixins: [Template],
})
class ProductCategories extends Vue {
	private router = useRouter();

	protected showModal(): void {
		this.$root?.$emit(
			'bv::show::modal',
			'productcategory-modal',
			'#productcategoryShow',
		);
	}

	protected routeProductCategory(id: string): void {
		this.router.push(`/productcategory/${id}`);
	}
}

export default toNative(ProductCategories);
